import sha256 from 'crypto-js/sha256'

/**
 * Generates a SHA-256 hash of the given input string, salted with the SHA-256 hash of the provided salt.
 *
 * @async
 * @param {string} input - The input string to hash.
 * @param {string} salt - The salt value to use, which will be hashed before concatenation.
 * @returns {Promise<string>} The resulting SHA-256 hash as a hexadecimal string.
 */
const hashString = async (input, salt) => {
  return sha256(input + sha256(salt).toString()).toString()
}

export default hashString
